export const SQD_TOKEN = 'tSQD';
export const SQD_DECIMALS = 18;

export const API_REQUEST_TIMEOUT_MS = 5_000;
export const API_UPSTREAM_TIMEOUT_MARGIN_MS = 500;
export const API_UPSTREAM_REQUEST_TIMEOUT_MS =
  API_REQUEST_TIMEOUT_MS - API_UPSTREAM_TIMEOUT_MARGIN_MS;
export const SERVER_REQUEST_TIMEOUT_MS = API_REQUEST_TIMEOUT_MS * 2;
